import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { Dropdown } from '@app/components';
import { ShapeWithClassName } from '@app/constants';

import {
  AdvancedSearchField,
  advancedSearchMessages,
  AdvancedSearchQualifier,
  BooleanOperator,
} from '../constants';

import './FieldsDropdown.scss';

interface FieldsDropdownProps {
  option: BooleanOperator | AdvancedSearchQualifier | AdvancedSearchField;
  typeOptions: string[];
  id: string;
  onSelect: (updatedField) => void;
}

const cnBem = createBemBlockBuilder(['advancedSearchDropdown']);

export const FieldsDropdown: FC<ShapeWithClassName<FieldsDropdownProps>> = ({
  option,
  typeOptions,
  id,
  className,
  onSelect,
}) => {
  const { $t } = useIntl();

  const options = useMemo(
    () =>
      typeOptions.map(field => ({
        label: $t(advancedSearchMessages[field]),
        value: field,
      })),
    [$t, typeOptions]
  );

  return (
    <Dropdown
      id={id}
      items={options}
      hideLabel
      styleType="standard"
      selectedItem={{
        label: $t(
          advancedSearchMessages[option] ||
            advancedSearchMessages[typeOptions[0]]
        ),
        value: option,
      }}
      className={cn(cnBem(), className)}
      onSelectedItemChange={({ selectedItem }) => onSelect(selectedItem?.value)}
    />
  );
};
